import React from "react";
import { AutocompleteWithEndAdornmentChip, LimitedTag } from "../../../shared";
import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";

const emptyInputStyle = {
  "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
    width: 0,
    minWidth: 0,
    padding: "0 !important",
  },
};

export const PlAndBsDashboardFilterSection = ({
  handleChangeFilter,
  state,
  validator,
  storeList = true,
  stateList = true,
}) => {
  const helperText = {
    ratio: validator.current.message(
      "Ratio",
      state.filter.values.ratio,
      "required"
    ),
    store: storeList
      ? validator.current.message(
          "Store",
          {
            store: state.filter.values.store,
            state: state.filter.values.state,
          },
          "storeOrState"
        )
      : "",
    state: stateList
      ? validator.current.message(
          "State",
          {
            store: state.filter.values.store,
            state: state.filter.values.state,
          },
          "storeOrState"
        )
      : "",
    financialYear: validator.current.message(
      "Financial year",
      state.filter.values.financialYear,
      "required"
    ),
    month: validator.current.message(
      "Month",
      state.filter.values.month,
      "required"
    ),
  };

  return (
    <React.Fragment>
      <AutocompleteWithEndAdornmentChip
        options={state.filter.options.ratios}
        label="Ratio"
        name="ratio"
        value={state.filter.values.ratio}
        handleChangeFilter={handleChangeFilter}
        groupBy={() => "All"}
        renderGroup={(params) => {
          const { values, options } = state.filter;
          const isChecked = values.ratio.length === options.ratios.length; //isAllChildChecked({ params });

          const handleHeaderClick = () => {
            handleChangeFilter({
              event: null,
              name: "ratio",
              value: isChecked ? [] : options.ratios,
            });
          };
          return (
            <React.Fragment key={params.group}>
              <ListItem
                onClick={handleHeaderClick}
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  ":hover": {
                    cursor: "pointer",
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                }}
              >
                <Checkbox size="small" checked={isChecked} />
                <Typography>{params.group}</Typography>
              </ListItem>
              <ListItemText>{params.children}</ListItemText>
            </React.Fragment>
          );
        }}
        limitedTag={(value) => (
          <LimitedTag
            labelKey="label"
            value={value}
            autocompleteWidth="230px"
            labelWidth="110px"
          />
        )}
        sx={{ minWidth: 230, maxWidth: "fit-content", ...emptyInputStyle }}
        helperText={helperText.ratio}
      />

      {stateList && (
        <AutocompleteWithEndAdornmentChip
          options={state.filter.options.states}
          label="State"
          name="state"
          value={state.filter.values.state}
          handleChangeFilter={handleChangeFilter}
          groupBy={() => "All"}
          renderGroup={(params) => {
            const { values, options } = state.filter;
            const isAllChecked = values.state.length === options.states.length;

            return (
              <React.Fragment key={params.group}>
                {params.key === 0 && (
                  <ListItemButton
                    disableGutters
                    onClick={() =>
                      handleChangeFilter({
                        event: null,
                        name: "state",
                        value: isAllChecked ? [] : options.states,
                      })
                    }
                    selected={isAllChecked}
                  >
                    <Checkbox size="small" checked={isAllChecked} />
                    <Typography>All</Typography>
                  </ListItemButton>
                )}

                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          limitedTag={(value) => (
            <LimitedTag
              labelKey="label"
              value={value}
              autocompleteWidth="230px"
              labelWidth="110px"
            />
          )}
          sx={{
            minWidth: 230,
            maxWidth: "fit-content",
            ...emptyInputStyle,
          }}
          helperText={helperText.state}
        />
      )}

      {storeList && (
        <AutocompleteWithEndAdornmentChip
          options={state.filter.options.stores}
          label="Store"
          name="store"
          value={state.filter.values.store}
          handleChangeFilter={handleChangeFilter}
          groupBy={(option) => option.franchisee_name}
          renderGroup={(params) => {
            const { values, options } = state.filter;
            const isAllChecked = values.store.length === options.stores.length;

            const fullOptions = options.stores.filter(
              (store) => store.franchisee_name === params.group
            );

            const selectedOptions = values.store.filter(
              (store) => store.franchisee_name === params.group
            );

            const isChecked = fullOptions.length === selectedOptions.length;

            const handleHeaderClick = ({ item }) => {
              if (item === "all") {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isAllChecked ? [] : options.stores,
                });
              } else {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isChecked
                    ? values.store.filter(
                        (store) =>
                          !selectedOptions.find(
                            (opt) =>
                              opt.franchisee_name === store.franchisee_name
                          )
                      )
                    : values.store.concat(
                        fullOptions.filter(
                          (option) =>
                            !values.store.find(
                              (selectedStore) =>
                                selectedStore.value === option.value
                            )
                        )
                      ),
                });
              }
            };

            return (
              <React.Fragment key={params.group}>
                {params.key === 0 && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: "all" })}
                    selected={isAllChecked}
                  >
                    <Checkbox size="small" checked={isAllChecked} />
                    <Typography>All</Typography>
                  </ListItemButton>
                )}
                {params.group && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: params.group })}
                    selected={isChecked}
                  >
                    <Checkbox size="small" checked={isChecked} />
                    <Typography fontWeight={500}>{params.group}</Typography>
                  </ListItemButton>
                )}
                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          limitedTag={(value) => (
            <LimitedTag
              labelKey="label"
              value={value}
              autocompleteWidth="230px"
              labelWidth="110px"
            />
          )}
          sx={{
            minWidth: 230,
            maxWidth: "fit-content",
            ...emptyInputStyle,
          }}
          helperText={helperText.store}
        />
      )}

      <InputControl
        type="dropdown"
        name="financialYear"
        label="Financial Year"
        disableCloseOnSelect
        disableClearable
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={state.filter.options.financialYears}
        value={state.filter.values.financialYear}
        onChange={(_, value) =>
          handleChangeFilter({ name: "financialYear", value })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Financial Year"
            placeholder="Financial year"
            helperText={helperText.financialYear}
            error={Boolean(helperText.financialYear)}
          />
        )}
        sx={{ minWidth: 150, maxWidth: "fit-content" }}
      />

      <AutocompleteWithEndAdornmentChip
        options={state.filter.options.accountMonths}
        label="Month"
        name="month"
        value={state.filter.values.month}
        handleChangeFilter={handleChangeFilter}
        renderOption={(props, option, { selected }) => {
          const selectedMonths = state.filter.values.month;

          const isQuarterSelected = selectedMonths.find(
            (month) => month.value === option?.quarter
          );

          const isYearlySelected = selectedMonths.find(
            (month) => month.value === "Yearly"
          );

          return (
            <ListItemButton
              {...props}
              key={option.value}
              disableGutters
              disabled={
                isYearlySelected
                  ? option.value === "Yearly"
                    ? Boolean(!isYearlySelected)
                    : Boolean(isYearlySelected)
                  : Boolean(isQuarterSelected)
              }
            >
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
                size="small"
              />
              {option.label}
            </ListItemButton>
          );
        }}
        limitedTag={(value) => (
          <LimitedTag
            labelKey="label"
            value={value}
            autocompleteWidth="180px"
            labelWidth="80px"
          />
        )}
        sx={{ minWidth: 200, maxWidth: "fit-content", ...emptyInputStyle }}
        helperText={helperText.month}
      />
    </React.Fragment>
  );
};
